export const getManageAccountLink = (subscriptionId: string): string => {
    return `https://app.gumroad.com/subscriptions/${subscriptionId}/manage`;
}
